import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import { InventoryService } from "src/app/api/inventory.service";

import { AppSettings } from "src/app/app-settings";

@Component({
  selector: "app-upload-modal",
  templateUrl: "./upload-modal.component.html",
  styleUrls: ["./upload-modal.component.scss"],
})
export class UploadModalComponent implements OnInit {
  uploadByLinkForm: FormGroup;
  uploadByLinkFormSftp: FormGroup;
  isWeb = AppSettings.IS_WEB;
  passwordType: string = "password";
  passwordIcon: string = "eye-off";
  tab = "uploadFile";
  selectedPath = "";
  toggle = true;
  linkInformationsHttps = {};
  linkInformationsSftp = {};
  currentLink: {};

  isSaved = false;

  constructor(
    private modalController: ModalController,
    public toastCtrl: ToastController,
    private formBuilder: FormBuilder,
    private loadingCtrl: LoadingController,
    private inventoryService: InventoryService
  ) { }

  ngOnInit() {
    this.uploadByLinkForm = this.formBuilder.group({
      Url: [
        null,
        Validators.compose([Validators.maxLength(200), Validators.required]),
      ],
      Protocol: [null, Validators.compose([Validators.required])],
      UsernameHttps: [
        null,
        Validators.compose([Validators.maxLength(30), Validators.required]),
      ],
      PasswordHttps: [
        null,
        Validators.compose([Validators.maxLength(30), Validators.required]),
      ],
    });

    this.uploadByLinkFormSftp = this.formBuilder.group({
      UrlSftp: [
        null,
        Validators.compose([Validators.maxLength(200), Validators.required]),
      ],
      Path: [null, Validators.compose([Validators.required])],
      Port: [null, Validators.compose([Validators.required])],
      UsernameSftp: [
        null,
        Validators.compose([Validators.maxLength(30), Validators.required]),
      ],
      PasswordSftp: [
        null,
        Validators.compose([Validators.maxLength(30), Validators.required]),
      ],
    });
  }

  show(tab) {
    this.tab = tab;
    this.selectedPath = tab;
    this.toggle = !this.toggle;
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  async handleUploadFileClick() {
    if (!AppSettings.IS_WEB) {
      const toast = await this.toastCtrl.create({
        message:
          "This action is not available in mobile version of our application.",
        duration: 3000,
        position: "bottom",
        showCloseButton: true,
        color: "warning",
      });
      toast.present();
    } else {
      document.getElementById("fileInput").click();
      this.dismissModal();
    }
  }

  hideShowPassword() {
    this.passwordType = this.passwordType === "text" ? "password" : "text";
    this.passwordIcon = this.passwordIcon === "eye-off" ? "eye" : "eye-off";
  }

  async ionViewWillEnter() {
    let t = this;
    let loader = await this.loadingCtrl.create({
      message: "Loading...",
    });

    loader.present();

    this.inventoryService
      .getFileInfos()
      .then((response) => {
        t.currentLink = response;
        t.loadData();
        loader.dismiss();
      })
      .catch(() => {
        t.loadingCtrl.dismiss();
      });
  }

  loadData() {
    if (this.currentLink["protocol"] == "HTTPS") {
      this.uploadByLinkForm.patchValue({
        Url: this.currentLink["url"],
        Protocol: this.currentLink["protocol"],
        UsernameHttps: this.currentLink["username"],
        PasswordHttps: this.currentLink["password"],
      });
    } else if (this.currentLink["protocol"] == "SFTP") {
      this.uploadByLinkForm.patchValue({
        Protocol: this.currentLink["protocol"],
      });
      this.uploadByLinkFormSftp.patchValue({
        UrlSftp: this.currentLink["url"],
        Path: this.currentLink["path"],
        Port: this.currentLink["port"],
        UsernameSftp: this.currentLink["username"],
        PasswordSftp: this.currentLink["password"],
      });
    }
  }

  cancelUpload() {
    let t = this;
    if (this.currentLink != null) {
      this.inventoryService.deleteUpload().then(async () => {
        t.toastCtrl.dismiss().catch(() => {
          //Do nothing, only occurs when there is no toast present
        });
        const toast = await t.toastCtrl.create({
          message: "Upload successfully deleted",
          duration: 1000,
          showCloseButton: true,
          position: "bottom",
          color: "success",
        });
        toast.present();
        this.resetUpload();
      });
    } else this.resetUpload();
  }

  resetUpload() {
    if (this.uploadByLinkForm.get("Protocol").value == "HTTPS") {
      this.uploadByLinkForm.reset();
    } else if (this.uploadByLinkForm.get("Protocol").value == "SFTP") {
      this.uploadByLinkFormSftp.reset();
    }
  }

  async saveInformationsLink() {
    if (!this.uploadByLinkForm.valid && !this.uploadByLinkFormSftp.valid) {
      return;
    }
    let loader = await this.loadingCtrl.create({
      message: "Saving...",
    });

    loader.present();
    let t = this;
    let form;

    // Case Protocol = HTTPS
    if (this.uploadByLinkForm.get("Protocol").value == "HTTPS") {
      this.linkInformationsHttps = {
        protocol: !!t.uploadByLinkForm.get("Protocol").value
          ? t.uploadByLinkForm.get("Protocol").value
          : "",
        url: !!t.uploadByLinkForm.get("Url").value
          ? t.uploadByLinkForm.get("Url").value
          : "",
        username: !!t.uploadByLinkForm.get("UsernameHttps").value
          ? t.uploadByLinkForm.get("UsernameHttps").value
          : "",
        password: !!t.uploadByLinkForm.get("PasswordHttps").value
          ? t.uploadByLinkForm.get("PasswordHttps").value
          : "",
        port: null,
        path: null,
      };
      form = this.linkInformationsHttps;
    }
    // Case Protocol = SFTP
    else if (this.uploadByLinkForm.get("Protocol").value == "SFTP") {
      this.linkInformationsSftp = {
        protocol: !!t.uploadByLinkForm.get("Protocol").value
          ? t.uploadByLinkForm.get("Protocol").value
          : "",
        url: !!t.uploadByLinkFormSftp.get("UrlSftp").value
          ? t.uploadByLinkFormSftp.get("UrlSftp").value
          : "",
        path: !!t.uploadByLinkFormSftp.get("Path").value
          ? t.uploadByLinkFormSftp.get("Path").value
          : "",
        port: !!t.uploadByLinkFormSftp.get("Port").value
          ? t.uploadByLinkFormSftp.get("Port").value
          : "",
        username: !!t.uploadByLinkFormSftp.get("UsernameSftp").value
          ? t.uploadByLinkFormSftp.get("UsernameSftp").value
          : "",
        password: !!t.uploadByLinkFormSftp.get("PasswordSftp").value
          ? t.uploadByLinkFormSftp.get("PasswordSftp").value
          : "",
      };
      form = this.linkInformationsSftp;
    }
    this.inventoryService
      .uploadFileInfos(form)
      .then(async () => {
        this.modalController.dismiss();
        this.isSaved = true;
        t.toastCtrl.dismiss().catch(() => {
          //Do nothing, only occurs when there is no toast present
        });

        const toast = await t.toastCtrl.create({
          message: "Inventory successfully uploaded",
          duration: 1000,
          showCloseButton: true,
          position: "bottom",
          color: "success",
        });
        toast.present();
      })
      .catch(async (errorResponse) => {
        let error = errorResponse.error;
        let errorMsg = "";

        Object.keys(error).forEach((key) => {
          errorMsg += key + " : ";

          error[key].forEach((errorCause, index) => {
            errorMsg += index > 0 ? ". " + errorCause : errorCause;
          });
        });

        t.toastCtrl.dismiss().catch(() => {
          //Do nothing, only occurs when there is no toast present
        });

        const toast = await t.toastCtrl.create({
          message: errorMsg,
          duration: 3000,
          showCloseButton: true,
          position: "bottom",
          color: "warning",
        });

        toast.present();
      })
      .finally(async () => {
        loader.dismiss();
      });
  }
}
